import React from 'react';
import { Layout } from 'antd';

import { connect } from 'react-redux';
import UserSidebar from './UserSidebar';
import ManagerSidebar from './ManagerSidebar';
import BuyerSidebar from './BuyerSidebar';
import AdminSidebar from './AdminSidebar';
import ResHeader from 'src/components/layout/ResHeader';
import ResFooter from 'src/components/layout/ResFooter';
import { getSidebarCollapsed, getUser } from 'src/redux/selectors';
import { collapseSidebar } from 'src/redux/actions/status';
import { useIsMobile } from 'src/utils/responsive';
import BackgroundImage from 'src/static/background.svg';
const { Content } = Layout;

if (window.innerWidth <= 440 || window.innerHeight <= 440) {
  window.isPhone = true;
} else {
  window.isPhone = false;
}
const Template = props => {
  const isMobile = useIsMobile();

  // On mobile the sidebar overlays the page rather than sitting beside it, so
  // the content keeps the full width and only the header height is reserved.
  const contentLayoutStyle = isMobile
    ? {
        transition: 'all 0.2s',
        margin: 8,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 72,
        // Desktop clips overflow; on mobile wide tables need to scroll instead.
        overflow: 'visible',
        minWidth: 0
      }
    : {
        transition: 'all 0.2s',
        margin: 10,
        overflow: 'hidden',
        marginLeft: props.collapsed ? '7em' : 'calc(7em + 200px)',
        marginRight: '4em',
        marginTop: 40
      };

  return (
    <div>
      <Layout style={{ minHeight: '100vh' }}>
        <ResHeader />
        <Layout>
          {props.user.type === 'user' ? (
            <UserSidebar />
          ) : props.user.type === 'manager' ? (
            <ManagerSidebar />
          ) : props.user.type === 'buyer' ? (
            <BuyerSidebar />
          ) : (
            <AdminSidebar />
          )}

          {/* Tap-anywhere backdrop while the sidebar is overlaying the page. */}
          {isMobile && !props.collapsed && (
            <div
              // collapseSidebar is a toggle; the backdrop only exists while the
              // sidebar is open, so toggling always closes it.
              onClick={() => props.collapseSidebar()}
              style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.45)',
                zIndex: 98
              }}
            />
          )}

          <Layout style={contentLayoutStyle}>
            <Content
              style={{
                transition: 'all 0.2s',
                margin: isMobile ? 0 : 10,
                minWidth: 0
              }}
            >
              {props.children}
            </Content>
            {/* <ResFooter /> */}
          </Layout>
        </Layout>
      </Layout>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    collapsed: getSidebarCollapsed(state),
    user: getUser(state) || {}
  };
};
const mapDispatchToProps = {
  collapseSidebar
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Template);
